import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import classes from './MembersEnrollmentsTable.module.scss'
import ProfileAvatar from '../../common/avatar/ProfileAvatar'
import { displayWithCurrency } from '../../../utility/currency'

const MembersEnrollmentsTable = ({ enrollments }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.enrollmentsTableWrapper}>
      <header className={classNames(classes.gridLayout, classes.tableHeader)}>
        <span>{t('members.enrollmentsTable.columns.student')}</span>
        <span>{t('members.enrollmentsTable.columns.program')}</span>
        <span>{t('members.enrollmentsTable.columns.packageAmount')}</span>
        <span>{t('members.enrollmentsTable.columns.paymentStatus')}</span>
        <span>{t('common.field.status')}</span>
      </header>
      {enrollments.map(enrollment => (
        <div key={enrollment.id} className={classNames(classes.row, classes.gridLayout)}>
          <div className={classNames(classes.col, classes.student)}>
            <ProfileAvatar student={enrollment.user} />
            <span className='font-weight-bold'>{enrollment.user.firstName} {enrollment.user.lastName}</span>
          </div>

          <div className={classes.col}>
            <span className='font-weight-bold'>{enrollment.course?.name}</span>
          </div>

          <div className={classes.col}>
            {enrollment.package ? (
              <span>
                {enrollment.package.name} - {displayWithCurrency(enrollment.amount, enrollment.community?.currency ?? { code: 'usd' }, true)}
              </span>
            ) : (
              <span>-</span>
            )}
          </div>

          <div
            className={
              classNames(
                classes.col,
                classes.paymentStatus,
                {
                  [classes.paid]: enrollment.paymentStatus === 'paid',
                  [classes.invoiced]: enrollment.paymentStatus === 'invoiced',
                }
              )
            }
          >
            <span>{enrollment.paymentStatus ?? '-'}</span>
          </div>

          <div
            className={
              classNames(
                classes.col,
                classes.status,
                {
                  [classes.completed]: enrollment.status === 'completed',
                  [classes.active]: enrollment.status === 'active',
                }
              )
            }
          >
            <span>{enrollment.status ?? '-'}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

MembersEnrollmentsTable.propTypes = {
  enrollments: PropTypes.array.isRequired,
}

export default MembersEnrollmentsTable
